import React, { useState } from 'react';
import { Botao, Campo } from '../../egora';

/**
 * Campo de senha do design EGORA, com o botão de mostrar e esconder.
 * `acaoDoRotulo` fica na linha do rótulo (ex.: "Esqueci minha senha").
 */
export default function CampoSenha({
  rotulo, valor, aoMudar, placeholder, autoComplete = 'current-password', acaoDoRotulo, ajuda, erro, onPaste, autoFocus,
}) {
  const [visivel, setVisivel] = useState(false);

  return (
    <Campo rotulo={rotulo} ajuda={ajuda} erro={erro} className="entrada__senha">
      {(p) => (
        <>
          {acaoDoRotulo && <span className="entrada__senha-acao">{acaoDoRotulo}</span>}
          <span className="entrada__senha-linha">
            <input
              {...p}
              className="sj-campo__entrada entrada__senha-entrada"
              type={visivel ? 'text' : 'password'}
              autoComplete={autoComplete}
              placeholder={placeholder}
              value={valor}
              onChange={(e) => aoMudar(e.target.value)}
              onPaste={onPaste}
              autoFocus={autoFocus}
            />
            <Botao
              variante="fantasma"
              tamanho="sm"
              icone={visivel ? 'visibility_off' : 'visibility'}
              rotulo={visivel ? 'Esconder senha' : 'Mostrar senha'}
              className="entrada__senha-olho"
              onClick={() => setVisivel((v) => !v)}
            />
          </span>
        </>
      )}
    </Campo>
  );
}
